import { __assign } from "tslib";
import React from 'react';
import classNames from 'classnames';
import { getBlockIndex } from './utils/draftUtils';
import { isPaywallSeo, getPaywallSeoClass } from './utils/paywallSeo';
import { getDirectionFromAlignmentAndTextDirection } from 'wix-rich-content-common';
import { getInteractionWrapper, DefaultInteractionWrapper, } from './utils/getInteractionWrapper';
var draftPublic = 'public-DraftStyleDefault';
var draftClassNames = function (listType, depth, textDirection) {
    return draftPublic + "-" + listType + "ListItem\n   " + draftPublic + "-depth" + depth + "\n   " + draftPublic + "-list-" + textDirection;
};
var getBlockClassName = function (isNewList, direction, listType, depth) {
    var className = draftClassNames(listType, depth, direction);
    if (isNewList) {
        className += " " + draftPublic + "-reset";
    }
    return className;
};
var List = function (_a) {
    var ordered = _a.ordered, items = _a.items, mergedStyles = _a.mergedStyles, textDirection = _a.textDirection, blockProps = _a.blockProps, getBlockStyleClasses = _a.getBlockStyleClasses, blockDataToStyle = _a.blockDataToStyle, getBlockDepth = _a.getBlockDepth, context = _a.context;
    var Component = ordered ? 'ol' : 'ul';
    var listType = ordered ? 'ordered' : 'unordered';
    var containerClassName = draftPublic + "-" + Component;
    var prevDepth = 0;
    return (React.createElement(Component, { className: containerClassName }, items.map(function (children, childIndex) {
        // NOTE: list block data is an array of data entries per list item
        var dataEntry = blockProps.data.length > childIndex
            ? blockProps.data[childIndex]
            : {};
        var interactions = blockProps.data[childIndex].interactions;
        var BlockWrapper = Array.isArray(interactions)
            ? getInteractionWrapper({ interactions: interactions, context: context })
            : DefaultInteractionWrapper;
        var paragraphGroup = [];
        var result = [];
        var textClassName = getBlockStyleClasses(dataEntry, mergedStyles, textDirection);
        var elementProps = function (key) { return ({
            className: classNames(mergedStyles.elementSpacing, textClassName),
            key: key,
        }); };
        React.Children.forEach(children, function (child, i) {
            if (child) {
                if (typeof child.type === 'string' && /h\d/.exec(child.type)) {
                    if (paragraphGroup.length) {
                        result.push(React.createElement("p", __assign({}, elementProps(i)), paragraphGroup));
                        paragraphGroup = [];
                    }
                    result.push(React.cloneElement(child, elementProps(i)));
                }
                else {
                    paragraphGroup.push(child);
                }
            }
        });
        if (paragraphGroup.length) {
            result.push(React.createElement("p", __assign({}, elementProps('just_some_key')), paragraphGroup));
        }
        var depth = getBlockDepth(context.contentState, blockProps.keys[childIndex]);
        var isNewList = childIndex === 0 || depth > prevDepth;
        var direction = getDirectionFromAlignmentAndTextDirection(dataEntry.textAlignment, textDirection || dataEntry.textDirection);
        var className = getBlockClassName(isNewList, direction, listType, depth);
        prevDepth = depth;
        var blockIndex = getBlockIndex(context.contentState, blockProps.keys[childIndex]);
        return (React.createElement("li", { id: "viewer-" + blockProps.keys[childIndex], className: classNames(getBlockStyleClasses(dataEntry, mergedStyles, textDirection, className, true), isPaywallSeo(context.seoMode) &&
                getPaywallSeoClass(context.seoMode.paywall, blockIndex)), key: blockProps.keys[childIndex], style: blockDataToStyle(blockProps.data[childIndex]) },
            React.createElement(BlockWrapper, null, result.length === 0 ? ' ' : result)));
    })));
};
export default List;
//# sourceMappingURL=List.js.map